/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FileText({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3.9 7.5a.6.6 0 0 1 .6-.6h7a.6.6 0 1 1 0 1.2h-7a.6.6 0 0 1-.6-.6M4.5 9.9a.6.6 0 0 0 0 1.2h5a.6.6 0 1 0 0-1.2z" /><path fill="currentColor" fillRule="evenodd" d="M1.4 3A2.6 2.6 0 0 1 4 .4h5.172a2.6 2.6 0 0 1 1.838.762L13.84 3.99a2.6 2.6 0 0 1 .761 1.838V13a2.6 2.6 0 0 1-2.6 2.6H4A2.6 2.6 0 0 1 1.4 13zM4 1.6A1.4 1.4 0 0 0 2.6 3v10A1.4 1.4 0 0 0 4 14.4h8a1.4 1.4 0 0 0 1.4-1.4V5.828a1.4 1.4 0 0 0-.41-.99L10.162 2.01a1.4 1.4 0 0 0-.99-.41z" clipRule="evenodd" /></svg>;
}
;